import { Co2Emission } from '@/lib/models/emissions/types';

type WtwMergeType = 'average' | 'sum';

export const mergeWtw = (
  wtwA?: Co2Emission,
  wtwB?: Co2Emission,
  mergeType: WtwMergeType = 'average',
): Co2Emission | undefined => {
  // If both are null, return null
  if (!wtwA && !wtwB) {
    return undefined;
  }

  // If only one of them exists, return that one
  if (!wtwA) return wtwB;
  if (!wtwB) return wtwA;

  // If they have different units, return null with error
  if (wtwA?.unit !== wtwB?.unit) {
    console.error('Cannot merge different Emission unit types', wtwA, wtwB);
    return undefined;
  }

  const calculate = (a: number, b: number) => {
    return mergeType === 'sum' ? a + b : (a + b) / 2;
  };

  // If both exist, merge and average their values
  return {
    wtw: calculate(wtwA.wtw, wtwB.wtw),
    ttw: calculate(wtwA.ttw || 0, wtwB.ttw || 0),
    wtt: calculate(wtwA.wtt || 0, wtwB.wtt || 0),
    unit: wtwA.unit,
  };
};
